import { render, staticRenderFns } from "./AddProductos.vue?vue&type=template&id=4a72c7a4&scoped=true&"
import script from "./AddProductos.vue?vue&type=script&lang=js&"
export * from "./AddProductos.vue?vue&type=script&lang=js&"
import style0 from "./AddProductos.vue?vue&type=style&index=0&id=4a72c7a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a72c7a4",
  null
  
)

export default component.exports